// extracted by mini-css-extract-plugin
export default {"container":"go-back-arrow_container__MP9hy","img":"go-back-arrow_img__CqzFH"};